import React, {FC} from 'react';
import {Col, Row} from 'react-bootstrap';
import orionLogo from '../../../assets/products/orion-logo.png';

import './styles.scss';

const ORION_URL = 'https://orion.hexowatch.com/';

const useCases = ['Price changes', 'Price drops below a target', 'New job posted', 'Back in stock', 'New blog post'];

interface IProps {
  variant?: 'light' | 'dark';
  className?: string;
}

const OrionMock: FC<{className?: string}> = ({className}) => (
  <div className={`orion-mock ${className || ''}`} aria-hidden="true">
    <div className="orion-mock__bar">
      <span />
      <span />
      <span />
      <div className="orion-mock__url">store.example.com/headphones</div>
    </div>
    <div className="orion-mock__body">
      <div className="orion-mock__img">
        <div className="orion-mock__headphones" />
      </div>
      <div className="orion-mock__info">
        <div className="orion-mock__brand">NORTHWIND AUDIO</div>
        <div className="orion-mock__name">Studio Wireless Headphones</div>
        <div className="orion-mock__old">$549</div>
        <div className="orion-mock__price">$479</div>
        <div className="orion-mock__cart">Add to cart</div>
        <div className="orion-mock__line" />
        <div className="orion-mock__line orion-mock__line--short" />
      </div>
    </div>
    <div className="orion-mock__prompt">Tell me when the price drops below $500</div>
  </div>
);

const OrionSection: FC<IProps> = ({variant = 'light', className}) => (
  <Row className={`orion-section orion-section--${variant} ${className || ''}`}>
    <Col lg={6} className="content-container px-3">
      <h2 className="page-title orion-section__title">
        <a href={ORION_URL} target="_blank" rel="noopener noreferrer" className="orion-section__logo">
          <img src={orionLogo} alt="Hexowatch OR:ON" />
        </a>
      </h2>
      <OrionMock className="d-lg-none my-4" />
      <p className="orion-section__lead">Tell OR:ON what matters. It watches and explains every change.</p>
      <p className="orion-section__text">
        Paste any page and say what you care about in plain words. OR:ON&apos;s AI checks it for you and alerts you only
        when it matters.
      </p>
      <ul className="orion-section__chips">
        {useCases.map(item => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <a href={ORION_URL} target="_blank" rel="noopener noreferrer" className="explore-btn">
        Explore OR:ON
      </a>
    </Col>
    <Col lg={6} className="d-none d-lg-flex align-items-center px-3">
      <OrionMock />
    </Col>
  </Row>
);

export default OrionSection;
